import { Inject, Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { EntityType } from '@planone/bau365/util-fair-data';
import { map, Observable, of } from 'rxjs';

import * as EnrichedWatchlistActions from './enriched-watchlist.actions';
import { ItemCategory } from './enriched-watchlist.models';
import * as EnrichedWatchlistSelectors from './enriched-watchlist.selectors';

import { WATCHLIST_CONFIG, WatchlistConfig } from '../../config/watchlist.config.interface';
import * as WatchlistSelectors from '../watchlist/watchlist.selectors';

@Injectable()
export class EnrichedWatchlistFacade {
  loaded$ = this.store.pipe(select(EnrichedWatchlistSelectors.isLoaded));
  itemCategory$ = this.store.pipe(select(EnrichedWatchlistSelectors.getItemCategory));
  currentPage$ = this.store.pipe(select(EnrichedWatchlistSelectors.getCurrentPage));
  pageCount$ = this.store.pipe(select(EnrichedWatchlistSelectors.getPageCount));
  itemsOnPage$ = this.store.pipe(select(EnrichedWatchlistSelectors.getItems));
  itemCount$ = this.store.pipe(select(EnrichedWatchlistSelectors.getItemCount));
  allItemCategories$ = this.store.pipe(
    select(WatchlistSelectors.getAllWatchlistItems),
    map((items) => [
      {
        category: ItemCategory.all,
        count: items.length,
      },
      {
        category: ItemCategory.exhibitor,
        count: items.filter((item) => item.entity_type === EntityType.exhibitor).length,
      },
      {
        category: ItemCategory.product,
        count: items.filter((item) => item.entity_type === EntityType.product).length,
      },
      {
        category: ItemCategory.post,
        count: items.filter((item) => item.entity_type === EntityType.post).length,
      },
      {
        category: ItemCategory.event,
        count: items.filter((item) => item.entity_type === EntityType.event).length,
      },
      {
        category: ItemCategory.brand,
        count: items.filter((item) => item.entity_type === EntityType.brand).length,
      },
    ])
  );
  pageSize$: Observable<number>;

  constructor(private readonly store: Store, @Inject(WATCHLIST_CONFIG) _watchlistConfig: WatchlistConfig) {
    this.pageSize$ = of(_watchlistConfig.pageSize);
  }

  public initWatchlist(page: number, itemCategory: ItemCategory) {
    this.store.dispatch(EnrichedWatchlistActions.init({ page, itemCategory }));
  }

  public openWatchlistPage(page: number) {
    this.store.dispatch(EnrichedWatchlistActions.openPage({ page }));
  }

  public setItemCategory(itemCategory: ItemCategory) {
    this.store.dispatch(EnrichedWatchlistActions.setItemCategory({ itemCategory }));
  }
}
